module.exports = __webpack_public_path__ + "img/vegetable-ramps-350x184.a5a98911.jpg";